import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AlertService, ResultService, AuthenticationService, UserService, DrawService, ToastService } from '../_services';
import { routingDraws } from './draw.routing';
import { HttpErrorInterceptor } from '../_interceptors';
import { TranslateModule } from "@ngx-translate/core";
import { NgxBarcodeModule } from 'ngx-barcode';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DrawComponent } from './draw.component';
import { PurchasePanelComponent } from './purchasepanel';
import { LuckySixComponent } from './lucky-six';
import { SimilarModule } from "../_common_component/similar.module";
import { LobbyComponent } from './lobby';
import { MyTicketsComponent } from "./my-tickets";
import { ViewticketComponent } from "./viewticket";
import { PurchaseConfirmPanelComponent } from './purchaseconfirm';
import { DrawmachineComponent } from "./drawmachine";
import { SuperKenoComponent } from './super-keno';
import { ThaiLotteryComponent } from './thai-lottery';
import { LotteryDiamondComponent } from './lottery-diamond';
import { ResultPanelComponent } from './resultpanel';
import { PurchaseConfirmPanel2Component } from './purchaseconfirm2';
import { PurchasePanel2Component } from './purchasepanel2';
import { NgxPaginationModule } from 'ngx-pagination';
import { CurrencySymbolPipe, CustomCurrencyPipe } from '../_directives';
import { ResultsComponent } from './results';
import { FiveByNinetyComponent } from './fiveByNinety';
import { TwelveByTwentyFourComponent } from './twelveByTwentyFour';
import { PowerBallComponent } from './powerBall';
import { OneByTwelveComponent } from './oneByTwelve';
import { BonusLottoComponent } from './bonusLotto';
import { PurchaseConfirmPanel3Component } from './purchaseconfirm3';
import { PurchasePanel3Component } from './purchasepanel3';
import { UserRegisterResolve } from '../_resolver';
import { Myanmar2DComponent } from './myanmar-2d';
import { SixByFortyTwoComponent } from './six-by-forty-two/six-by-forty-two.component';
import { FiveByThirtySixComponent } from './five-by-thirty-six/five-by-thirty-six.component';
import { SixByFortyTwoMegaMillionComponent } from './six-by-forty-two-mega-million/six-by-forty-two-mega-million.component';
import { FiveByFortyNineLottoWeeklyComponent } from './five-by-forty-nine-lotto-weekly/five-by-forty-nine-lotto-weekly.component';
import { BichoRapidoComponent } from './bicho-rapido/bicho-rapido.component';
import { ZeroTONineComponent } from './zero-tonine';
import { LottoAmigoComponent } from './lotto-amigo/lotto-amigo.component';;
import { MiniRouletteComponent } from './mini-roulette/mini-roulette.component';;
import { EightByTwentyFourComponent } from './eight-by-twenty-four/eight-by-twenty-four.component';;
import { SixByFiftyComponent } from './six-by-fifty/six-by-fifty.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    routingDraws,
    CommonModule,
    TranslateModule,
    NgxBarcodeModule,
    NgbModule,
    SimilarModule,
    NgxPaginationModule
  ],

  declarations: [
    DrawComponent,
    LuckySixComponent,
    SuperKenoComponent,
    ThaiLotteryComponent,
    LotteryDiamondComponent,
    Myanmar2DComponent,
    TwelveByTwentyFourComponent,
    PowerBallComponent,
    BonusLottoComponent,
    FiveByNinetyComponent,
    OneByTwelveComponent,
    PurchasePanelComponent,
    PurchasePanel2Component,
    PurchasePanel3Component,
    PurchaseConfirmPanelComponent,
    PurchaseConfirmPanel2Component,
    PurchaseConfirmPanel3Component,
    ResultPanelComponent,
    LobbyComponent,
    MyTicketsComponent,
    ViewticketComponent,
    DrawmachineComponent,
    ResultsComponent,
    SixByFortyTwoComponent,
    FiveByThirtySixComponent ,
    SixByFortyTwoMegaMillionComponent,
    FiveByFortyNineLottoWeeklyComponent,
    BichoRapidoComponent,
    LottoAmigoComponent,
    ZeroTONineComponent,
    MiniRouletteComponent,
    EightByTwentyFourComponent,
    SixByFiftyComponent,
  ],
    
  providers: [
    UserRegisterResolve,
    AlertService,
    ResultService,
    AuthenticationService,
    UserService,
    DrawService,
    CurrencySymbolPipe,
    CustomCurrencyPipe,
    //   {
    //     provide: HTTP_INTERCEPTORS,
    //     useClass: HttpErrorInterceptor,
    //     multi: true
    // },
    ToastService
  ]
})

export class DrawModule { }

